import Image from "next/image";

export default function Socials() {
    const socials = [
        {src: "/images/social/facebook.svg", alt: "Facebook", href: "/"},
        {src: "/images/social/twitter.svg", alt: "Twitter", href: "/"},
        {src: "/images/social/youtube.svg", alt: "Youtube", href: "/"},
        {src: "/images/social/instagram.svg", alt: "Instagram", href: "/"},
    ];

    return (
        <div className={"flex gap-3 mt-4 mb-4"}>
            {
                socials.map((s, index) => (
                    <a key={index} href={s.href}>
                        <Image
                            src={s.src}
                            alt={s.alt}
                            width={28}
                            height={28}
                        />
                    </a>
                ))
            }
        </div>
    );
}
